/**
 * Tipos de entradas de menu
 */
enum MenuType {
    Main = 'main',
    Collection = 'collection',
    Link = 'link',
    Resource = 'resource',
    None = 'none',
}

export default MenuType
